import { put, select, take, takeLatest } from 'redux-saga/effects';

import { targetUserIdSelector } from '../../../context/selectors';
import { CIRCLE_ACTION_TYPES } from '../../constants';
import * as leaveFamilyCircle from '../../leaveFamilyCircle';
import * as circleOfCare from '../../../board/circleOfCare';
import * as success from '../../../ui/success';

function* removeMemberWorker({ payload }) {
  const userId = yield select(targetUserIdSelector);

  yield put(
    leaveFamilyCircle.actions.send({
      memberId: payload,
      userId,
    }),
  );

  yield take(leaveFamilyCircle.consts.SUCCEED);

  yield put(circleOfCare.actions.removeFamilyCircleItem(payload));

  yield put({
    type: success.consts.UPDATE,
    payload: { id: 'circles.family.remove' },
  });
}

export default function* circleOfCareActionsSaga() {
  yield takeLatest(CIRCLE_ACTION_TYPES.REMOVE_MEMBER, removeMemberWorker);
}



// WEBPACK FOOTER //
// ./src/redux/circles/sagas/circle-of-care/remove-member-saga.js